import { restApi } from "@redux/restApi";

interface UploadSequoiaPayload {
  file: File;
}

export interface UploadResult {
  successfulRows: number;
  erroredRows: Record<string, string>[];
}

export const uploadSequoiaRestApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    uploadSequoia: build.mutation<UploadResult, UploadSequoiaPayload>({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("files", file);

        return {
          url: "sequoia",
          method: "POST",
          mode: "cors",
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadSequoiaMutation } = uploadSequoiaRestApi;
